import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/components/ui/use-toast";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { ScrollReveal } from "./ScrollReveal";
import { Send } from "lucide-react";
import axios from "axios";

export const ContactForm = () => {
  const { toast } = useToast();
  const [eventType, setEventType] = useState("firmowe");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      await axios({
        method: 'POST',
        url: 'https://form.aigency.pl/api/form',
        data: {
          website: 'WystepKomediowy.pl',
          email: formData.get('email'),
          destinationEmail: 'kontakt@wystepkomediowy.pl',
          fields: {
            "Imię i nazwisko": formData.get('name'),
            "Numer telefonu": formData.get('phone'),
            "Rodzaj wydarzenia": eventType === 'firmowe' ? 'Wydarzenie firmowe' : 'Impreza prywatna',
            "Wiadomość": formData.get('message'),
          }
        }
      });

      form.reset();
      toast({
        title: "Sukces",
        description: "Twoje zapytanie zostało wysłane. Skontaktujemy się z Tobą wkrótce.",
      });
    } catch {
      toast({
        title: "Błąd",
        description: "Wystąpił błąd podczas wysyłania zapytania. Spróbuj ponownie później.",
        variant: "destructive",
      });
    }
  };

  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-white to-gray-50/50" id="kontakt">
      <div className="container max-w-2xl">
        <ScrollReveal>
          <h2 className="section-heading">
            Zamów <span className="gradient-text">występ</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <form onSubmit={handleSubmit} className="space-y-6 rounded-3xl p-8 md:p-10 bg-white shadow-2xl shadow-brand-purple/5 border border-gray-100">
            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <label className="font-inter text-sm font-medium mb-2 block text-gray-700">Imię i nazwisko</label>
                <Input
                  name="name"
                  required
                  className="rounded-xl border-gray-200 focus:border-brand-purple focus:ring-brand-purple/20 h-12"
                />
              </div>
              <div>
                <label className="font-inter text-sm font-medium mb-2 block text-gray-700">Email</label>
                <Input
                  name="email"
                  type="email"
                  required
                  className="rounded-xl border-gray-200 focus:border-brand-purple focus:ring-brand-purple/20 h-12"
                />
              </div>
            </div>

            <div>
              <label className="font-inter text-sm font-medium mb-2 block text-gray-700">Numer telefonu</label>
              <Input
                name="phone"
                type="tel"
                required
                className="rounded-xl border-gray-200 focus:border-brand-purple focus:ring-brand-purple/20 h-12"
              />
            </div>

            <div className="space-y-3">
              <label className="font-inter text-sm font-medium block text-gray-700">Rodzaj wydarzenia</label>
              <RadioGroup defaultValue="firmowe" onValueChange={setEventType} className="flex gap-4">
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="firmowe" id="firmowe" className="border-brand-purple/40 text-brand-purple" />
                  <Label htmlFor="firmowe" className="text-gray-600 cursor-pointer">Wydarzenie firmowe</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="prywatne" id="prywatne" className="border-brand-purple/40 text-brand-purple" />
                  <Label htmlFor="prywatne" className="text-gray-600 cursor-pointer">Impreza prywatna</Label>
                </div>
              </RadioGroup>
            </div>

            <div>
              <label className="font-inter text-sm font-medium mb-2 block text-gray-700">Wiadomość</label>
              <Textarea
                name="message"
                required
                className="min-h-[140px] rounded-xl border-gray-200 focus:border-brand-purple focus:ring-brand-purple/20"
              />
            </div>

            <Button
              type="submit"
              className="w-full h-12 rounded-xl bg-brand-purple hover:bg-brand-purple-dark text-white transition-all duration-300 shadow-lg shadow-brand-purple/20 hover:shadow-xl hover:shadow-brand-purple/30 text-base font-semibold flex items-center justify-center gap-2"
            >
              <Send className="w-4 h-4" />
              Wyślij zapytanie
            </Button>
          </form>
        </ScrollReveal>

        <ScrollReveal delay={0.4}>
          <div className="mt-16 text-center">
            <div className="inline-block rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 shadow-lg shadow-brand-purple/5 px-8 py-6">
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">Właścicielem serwisu jest</p>
              <p className="text-lg font-montserrat font-bold text-primary">Wirtualny Biznes</p>
              <div className="mt-2 space-y-0.5 text-sm text-gray-500">
                <p>ul. Księcia Witolda 49/15</p>
                <p>50-202 Wrocław</p>
                <p className="mt-2 font-medium text-gray-600">NIP: 8961619199</p>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
